<template>
  <div class="product-info-block-comp">

    <div v-if="title"
         class="primary--text semanticsection-title2"> {{ title }}
    </div>

    <v-container v-for="(section, index) in sections"
         :key="index"
         class="product-info-section pa-0"
         fluid>

      <div v-if="showsubtitles"
           class="primary--text subueber">{{ section.sectionTitle }}
      </div>

      <v-row no-gutters>

        <div v-for="(item, inner_index) in section.items"
             :key="inner_index"
             class="single-product-line">

          <div class="thumbnail-container">
            <img src="@/assets/svg/ic_pdf.svg"
                 class="thumbnail"
                 alt="PDF Download">
          </div>

          <div class="thumbnailText">
            <div class="thumbnailDescription">{{ item.title }}</div>
            <a v-if="item.link"
               :href="item.link"
               target="_blank"
               class="link">
                <span>PDF in neuem Tab öffnen
                <v-icon>open_in_new
                </v-icon></span>
            </a>
          </div>

        </div>

      </v-row>

    </v-container>

  </div>

</template>

<script>
export default {
  name: "ProductInfoBlock",
  props: {
    title: {
      type: String,
      default: ""
    },
    sections: {
      type: Array,
      required: true
    },
    showsubtitles: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>

.product-info-block-comp .subueber {
  margin: 40px 0;
}

.product-info-block-comp .semanticsection-title2 + .product-info-section .subueber {
  margin-top: 0 !important;
}

.product-info-block-comp .product-info-section {
  margin-bottom: -40px;
}

.product-info-block-comp .product-info-section > .row {
  display: flex;
  justify-content: space-between;
}

.product-info-block-comp .product-info-section .single-product-line {
  display: flex;
  width: 354px;
  min-width: 354px;
  margin-bottom: 40px;
}

.product-info-block-comp .link {
  color: rgba(0, 0, 0, .87) !important;
  position: absolute;
  bottom: 10px;
}

.product-info-block-comp .link .v-icon {
  text-decoration: none !important;
  color: rgba(0, 0, 0, .87);
  padding-bottom: 3px;
}

.product-info-block-comp a:hover span {
  text-decoration: underline !important;
  color: #0085CF;
}

.product-info-block-comp a:hover .v-icon {
  color: #0085CF;
}

.product-info-block-comp .thumbnail-container {
  width: 80px;
  height: 85px;
  margin: 0 8px;
}

.product-info-block-comp .thumbnail {
  width: 100%;
  height: 100%;
}

.product-info-block-comp .thumbnailText {
  width: 100%;
  max-width: calc(100% - 80px);
  position: relative;
  padding: 0 8px;
  font-size: 14px;
}

.product-info-block-comp .thumbnailText .v-icon {
  font-size: 14px;
}

.product-info-block-comp .thumbnailDescription {
  font-size: 16px;
  color: #002C76 !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
